import { times } from 'lodash';
import ReactDOMServer from 'react-dom/server';

const SLOT_QUANTITY = 4;
const NETWORK = '36117602';
const DIV_PREFIX = 'jam_adSuggestive';

const elementIds = times(SLOT_QUANTITY, (i) => `${DIV_PREFIX}${i}`);

export function createAdDivs(): void {
  // Create a divs for the slots

  const container = ReactDOMServer.renderToStaticMarkup(
    <div className="container">
      {elementIds.map((elementId) => (
        <div key={elementId} className="ad" id={elementId} />
      ))}
      <style jsx>{`
        .container {
          width: 0;
          height: 0;
          display: none;
        }

        .ad {
          width: 0;
          height: 0;
        }
      `}</style>
    </div>
  );

  document.body.insertAdjacentHTML('beforeend', container);
}

export function createListener(callback: (data: unknown) => void): () => void {
  const handler = (e: MessageEvent): void => {
    const { origin } = e;

    if (
      !(
        origin.includes('googlesyndication.com') &&
        e.data.task &&
        e.data.task === 'suggloaded' &&
        e.data.adunit.includes(NETWORK)
      )
    ) {
      return;
    }

    callback(e.data);
  };
  window.addEventListener('message', handler, false);

  return (): void => {
    window.removeEventListener('message', handler);
  };
}

export function loadAndDisplayAds(adUnitPath: string): void {
  googletag.cmd.push(() => {
    elementIds.forEach((elementId) => {
      if (!document.getElementById(elementId)) {
        throw new Error(`No matching div found for #${elementId}, cannot define ad slot`);
      }

      const slot = googletag.defineSlot(adUnitPath, 'fluid', elementId);

      // Sometimes these slots come back undefined from google due to no fault of our own
      if (!slot) {
        return;
      }

      slot.setTargeting('slot', 'suggestive');
      slot.addService(googletag.pubads());
      googletag.display(elementId);

      googletag.pubads().refresh([slot]);
    });
  });
}
